
import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { NJDocData, NJDocDefTemplate, DOData, componentVM, NJReadDocDefTemplateLookup, DocdefDataVM } from '../DOData';
import { RowNode, IDatasource, CellClickedEvent } from 'ag-grid-community';
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
import { CheckboxRendererComponent } from '../rendering/checkbox-cell-rending/checkbox-cell-rending.component';
import { ButtonRendererComponent } from '../rendering/button-cell-rendering/button-cell-rending.component';
import { DropdownRendererComponent } from '../rendering/dropdown-cell-rendering/dropdown-cell-rending.component';
//Updating to optimize the code - modified teh filter to find to reduce the iterations, which is not required
@Component({
    selector: 'cylib-grid-internal-ag-grid',
    templateUrl: './grid-internal-ag-grid.component.html',
    styleUrls: ['./grid-internal-ag-grid.component.css']
})
export class GridInternalAgGridComponent implements OnInit, AfterViewInit {
     
    @Input() DocDefTemplate: NJDocDefTemplate
    @Input() public loaderKey: string;
    @Input() public parentLoaderKey: string = "";

    @Input() lstDocData: Array<NJDocData> = new Array<NJDocData>();
    @Input() lstChildDocDefTemplate: Array<NJDocDefTemplate>;
    @Input() lstDocDefTemplateLookup: Array<NJReadDocDefTemplateLookup>;
    @Input() customParameters: any;
    @Input() allowDoubleClick: boolean;
    @Input() cutoffDate: string;


    @Input() isValid: boolean = true;
    @Input() isHideTitles: boolean = false;
    @Input() isEnabled: boolean = true;

    @Input() GridID: any
    @Input() isPopUpYesNo: string;
    @Input() isPopUpSelected: boolean = false;

    @Input() public hasEvent: boolean = false;

    @Input() public skipAGGridChkBoxPostDocDefData: boolean = false;

    @Output() editItem: EventEmitter<Array<DOData>> =
        new EventEmitter<Array<DOData>>();

    @Output() clickBut: EventEmitter<DOData> =
        new EventEmitter<DOData>();

    @Output() doubleClick: EventEmitter<DOData> =
        new EventEmitter<DOData>();

    @Output() tabEvent: EventEmitter<componentVM> =
        new EventEmitter<componentVM>();

    @Output() clickLink: EventEmitter<DOData> =
        new EventEmitter<DOData>();

    @Output() requestRows: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Output() gridReady: EventEmitter<DOData> =
        new EventEmitter<DOData>();

    @Output() selectedRowData: EventEmitter<any> = 
        new EventEmitter();
    @Output() cellClicked: EventEmitter<DOData> =
        new EventEmitter<DOData>();

    public height = 500;
    public rowHeight;
    public width = 100;

    private ExternalFilterModel: string = "";
    private ExternalFilterKey: string = "";
    
    private _columnDefs: any[];
    get columnDefs(): any[] {
        return this._columnDefs;
    }
    set columnDefs(value: any[]) {
        this._columnDefs = value;
    }
    private _rowData: any[];
    get rowData(): any[] {
        return this._rowData;
    }
    set rowData(value: any[]) {
        this._rowData = value;
    }
    _getRows: number[];
    get getRows(): number[] {
        return this._getRows;
    }
    set getRows(value: number[]) {
        this._getRows = value;
    }
    public gridOptions = {
        onFirstDataRendered: this.headerHeightSetter,
        onColumnResized: this.headerHeightSetter,
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            headerComponentParams: {
                template:
                    '<div class="ag-cell-label-container" role="presentation">' +
                    '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                    '  <div ref="eLabel" class="ng-deep ag-header-cell-label ag-header-cell-text" role="presentation">' +
                    '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
                    '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
                    '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
                    '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
                    '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal !important;"></span>' +
                    '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                    '  </div>' +
                    '</div>',
            },
            pdfExportOptions: {}
        },
        //pagination
        pagination: false,
        paginationPageSize: 10,
        // Setting Last Row Index
        cacheBlockSize: 1000,
        rowDeselection: true,
        accentedSort: true
    }
    private gridIsSecondary: boolean = false;
    //private FirstDisplayedRow: number;
    //private LastDisplayedRow: number;
    public components;
    public frameworkComponents;
    private cacheData: boolean;

    public gridApi;
    public gridColumnApi;
    public params;

    public rowBuffer;
    public defaultColDef;
    public rowModelType;
    public rowSelection;
    public maxBlocksInCache;
    public getRowNodeId;
    public cacheOverflowSize;
    public maxConcurrentDatasourceRequests;
    public infiniteInitialRowCount;
    public datasource;
    public suppressRowClickSelection;

    public loadingTemplate: string;
    public noRowsTemplate: string;

    private selectionStartIndex: number | null = null;
    public isHidden: boolean = false;
    errorMessage: string;
    // declare a property object to hold row data
    public selectedRow = {};
    public selectedRowkeyTemplateId = -1;

    private _cellRendererParamsDefs: any[];
    get cellRendererParamsDefs(): any[] {
        return this._cellRendererParamsDefs;
    }
    set cellRendererParamsDefs(value: any[]) {
        this._cellRendererParamsDefs = value;
    }

    constructor(public data: DocDefPrimLibService) {
        this.defaultColDef = { resizable: true };
        //this.columnDefs = getColumnDefs();
        this.rowBuffer = 0;
        this.rowModelType = "infinite";
        // this.rowSelection = "multiple";
        this.cacheOverflowSize = 2;
        this.maxConcurrentDatasourceRequests = 1;
        this.infiniteInitialRowCount = 1000;
        this.maxBlocksInCache = 30;

        this.frameworkComponents = {
            CheckboxRendererComponent: CheckboxRendererComponent,
            ButtonRendererComponent: ButtonRendererComponent,
            DropdownRendererComponent: DropdownRendererComponent
        };

    }
    onCellKeyDown(event: any) {
        try {
            const e = event.event as KeyboardEvent;
            var gridApi = event.api;
            var rowIndex = event.node.rowIndex;
            var rowCount = gridApi.getDisplayedRowCount();
            if (this.gridColumnApi.getAllDisplayedColumns().find(c => c.userProvidedColDef.headerName == 'SSN')) {
                if (gridApi)
                    if (e.key.toLocaleLowerCase() == 'a' && (e.ctrlKey || e.metaKey)) {
                        e.preventDefault();
                        gridApi.forEachNode((node) => {
                            node.setSelected(true);
                        });
                        this.selectionStartIndex = 0;
                        return;
                    }
                if (this.selectionStartIndex === null || this.selectionStartIndex === undefined) {
                    this.selectionStartIndex = rowIndex;
                }
                let targetIndex = rowIndex;
                if (e.key === 'ArrowDown') {
                    targetIndex = e.ctrlKey ? rowCount - 1 : rowIndex + 1;
                    if (targetIndex >= rowCount) return;
                }
                if (e.key === 'ArrowUp') {
                    targetIndex = e.ctrlKey ? 0 : rowIndex - 1;
                    if (targetIndex < 0) return;
                }
                if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                    if (e.shiftKey) {
                        gridApi.deselectAll();
                        let start = Math.min(this.selectionStartIndex, targetIndex);
                        let end = Math.max(this.selectionStartIndex, targetIndex);
                        gridApi.forEachNode((node) => {
                            if (node.rowIndex >= start && node.rowIndex <= end) {
                                node.setSelected(true);
                            }
                        });
                    }
                    else {
                        gridApi.deselectAll();
                        gridApi.getDisplayedRowAtIndex(targetIndex).setSelected(true);
                        this.selectionStartIndex = targetIndex;
                    }
                    gridApi.setFocusedCell(targetIndex, event.column.colId);
                    gridApi.ensureIndexVisible(targetIndex);
                    return;
                }
                if (e.key == 'c' && (e.ctrlKey || e.shiftKey || e.metaKey)) {
                    e.preventDefault();

                    this.copySelectedRows();
                    //KEEP THE FOCUS ON GRID
                    gridApi.setFocusedCell(rowIndex, event.column.colId);
                }
            }
        } catch (error) {
            console.error('Error in onCellKeyDown:', error);
        }
    }
    private copySelectedRows() {
        try {
            const selected = this.gridApi.getSelectedRows();
            if (!selected.length) { return; }
            var fromPage = this.data.FromPage;
            const cols = this.gridColumnApi.getAllDisplayedColumns().filter(c => c.userProvidedColDef.headerName !== 'SSN');
            let dataMatrix = selected.map(row =>
                cols.map(c => {
                    let value = row[c.getColId()];
                    if (c.userProvidedColDef.headerName === 'SSN') {
                        if (value !== null && value.length > 0 ) {
                            const lastFour = value.slice(-4);
                            value = `XXX-XX-XXXX`;
                        }
                    }
                    //treat default date as empty
                    else if (value === '1/1/1900' || value === '01/01/1900') {
                        value = '';
                    }
                    else if (value !== undefined && value !== null && (c.userProvidedColDef.headerName === 'DOB') ||
                        c.userProvidedColDef.headerName === 'Opened' || c.userProvidedColDef.headerName === 'Transition Date') {
                        const dateValue = value ? value.split(' ')[0] : '';
                        value = dateValue + "\u200B";
                    }
                    return value !== null && value !== undefined ? value : '';
                }));
            //Find how many trailing empty columns exist
            let lastValidColIndex = dataMatrix[0].length - 1;
            //Move backwards until we find a column that has at least one value
            while (lastValidColIndex >= 0 && dataMatrix.every(row => row[lastValidColIndex] === '')) {
                lastValidColIndex--;
            }
            //Trim all rows to that last valid column
            dataMatrix = dataMatrix.map(row => row.slice(0, lastValidColIndex + 1));

            const rows = dataMatrix.map(row => row.join('\t'));
            const tsv = rows.join('\n');

            const textarea = document.createElement('textarea');
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            textarea.value = tsv;

            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
        } catch (error) {
            console.error('Error in copySelectedRows:', error);
        }
    }

    isvalid(): string {
        if (!this.isValid)
            return "border border-danger";
        else
            return "";
    }
    ngAfterViewInit(): void {
        this.headerHeightSetter();
    }
    
    onGridReady(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.headerHeightSetter();       

        let _this = this;
        if (params.sortModel == undefined) {
            params.sortModel = [];
        }
        var dataSource = {
            rowCount: null,
            getRows: function (params) {
                // ********************************************
                // the params set by the user in the front end
                // not from the grid column header
                // ********************************************
                //if (_this.params != undefined) {
                //    //params.FilterModel = "{" + _this.ExternalFilterKey + ":" + _this.ExternalFilterModel + "}";
                //    if (Object.keys(_this.params.filterModel)[0] != undefined)
                //        params.filterModel = _this.params.filterModel;
                //}

                _this.params = params;
                _this.onRequestRows(true);

                _this.data.loadGridData(_this.DocDefTemplate.templateCode, params, _this.loaderKey, _this.cutoffDate, _this.parentLoaderKey)
                    .subscribe(
                        (ret: boolean) => {
                            if (ret) {
                                params.context = _this.DocDefTemplate;
                                // get data from web service
                                let lstDocDataLocal: Array<NJDocData> = new Array<NJDocData>();
                                if (_this.data.gridDataVM.docdata) {
                                    lstDocDataLocal = _this.data.gridDataVM.docdata;

                                    if (!_this.cacheData || _this.gridIsSecondary) {
                                        if (params.startRow == 0)
                                            _this._getRows = [];
                                        //get unique rows and the field to be sorted on (default to first field)
                                        for (let i: number = 0; i < lstDocDataLocal.length; i++) {
                                            if (_this.getRows.map(function (e) { return e }).indexOf(lstDocDataLocal[i].docDefDataRowID) === -1) {
                                                _this.getRows.push(lstDocDataLocal[i].docDefDataRowID)
                                            }
                                        }
                                    }
                                }
                                // read ponters into array
                                let rowDataLocal: Array<number> = new Array<number>();
                                for (let i: number = 0; i < lstDocDataLocal.length; i++) {
                                    if (rowDataLocal.map(function (e) { return e }).indexOf(lstDocDataLocal[i].docDefDataRowID) === -1)
                                        rowDataLocal.push(lstDocDataLocal[i].docDefDataRowID);
                                }

                                //for (let item of lstDocDataLocal) {
                                //    if (rowDataLocal.length == 0)
                                //        rowDataLocal.push(item.docDefDataRowID)
                                //    if (rowDataLocal[rowDataLocal.length - 1] != item.docDefDataRowID)
                                //        rowDataLocal.push(item.docDefDataRowID);
                                //}
                                var rowsThisPage = [];
                                setTimeout(function () {
                                    for (var rowIndex = 0; rowIndex < params.endRow - params.startRow; rowIndex++) {
                                        var record = {};
                                        //let docDataRowID = _this.getRows[rowIndex];
                                        let docDataRowID = rowDataLocal[rowIndex];
                                        for (let template of _this.lstChildDocDefTemplate) {                                            
                                            let data = lstDocDataLocal.find(d => d.docDefDataRowID == docDataRowID && d.docDefTemplateID == template.docDefTemplateID);
                                            record["T" + template.docDefTemplateID.toString()] = data ? data.dataValue : "";                                            
                                            record["id"] = docDataRowID == undefined ? null : docDataRowID.toString();
                                        }
                                        rowsThisPage.push(record);
                                    }
                                    //defect 33152
                                    params.successCallback(rowsThisPage, _this.getLastRowIndex(rowDataLocal.length + params.startRow, params));
                                    //defect 33152 end
                                    if (_this.getRows.length == 0)
                                        _this.gridApi.showNoRowsOverlay();
                                    else
                                        _this.gridApi.hideOverlay();
                                    _this.onRequestRows(false);

                                }, 500);
                            }

                        }
                    )
                    ,
                    (err: any) => console.log(err),
                    () => {
                    }
            }
        }
        params.api.setDatasource(dataSource);

        let DOMessage: DOData = new DOData();
        DOMessage.njDocData = new NJDocData();
        DOMessage.njDocData.dataValue = null;
        DOMessage.njDocDefTemplate = this.DocDefTemplate;
        DOMessage.lstChildDocDefTemplate = this.lstChildDocDefTemplate;
        DOMessage.customParameters = null;
        this.gridReady.emit(DOMessage);
        //this.autoSizeAll(false);
    }


    getLastRowIndex(currentLastRow, params) {
        if (!params) return undefined;
        return currentLastRow < params.endRow ? currentLastRow : params.endRow + 1;
    }
    //autoSizeAll(skipHeader) {
    //    var allColumnIds = [];
    //    this.gridColumnApi.getAllColumns().forEach(function (column) {
    //        allColumnIds.push(column.colId);
    //    });
    //    this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    //}
    //getGridData(templateCode: string, sortModel: any) {
    //    this.data.loadGridData(templateCode, sortModel)
    //        .subscribe(
    //            (ret: boolean) => {
    //                if (ret) {
    //                    let localGridData = new Array<NJDocData>();
    //                    this.loaderKey = this.data.gridDataVM.loaderKey;
    //                    for (let doData of this.data.gridDataVM.docdata) {
    //                        let newLst = new Array<DOData>();

    //                        localGridData.push(DocDefPrimLibService.createNew(doData));

    //                        localGridData.push(doData)
    //                    }
    //                    this.lstDocData = localGridData;
    //                }
    //            }, 
    //            (err: any) => console.log(err),
    //            () => {
    //            }
    //        );
    //}
    ngOnInit() {
        this.hide_grid();
        this.calc_data();
        if (this.customParameters.rowSelection) {
            if (this.customParameters.rowSelection = "Single") {
                this.rowSelection = "single";
            }
            else {
                this.rowSelection = "multiple";
            }
        }
        else {
            this.rowSelection = "multiple";
        }

        if (this.customParameters.TableHeight != null) {
            this.height = this.customParameters.TableHeight
        }

        if (this.customParameters['hasEvent'] != null) {
            this.hasEvent = true;
        }

        if (this.customParameters.rowHeight != null) {
            this.rowHeight = this.customParameters.rowHeight
        }

        if (this.customParameters.suppressRowClickSelection != null) {
            this.suppressRowClickSelection = true;
        }
        else
            this.suppressRowClickSelection = false;

        if (this.customParameters.EndRow) {
            this.gridOptions.cacheBlockSize = Number(this.customParameters.EndRow);
            this.infiniteInitialRowCount = Number(this.customParameters.EndRow);
        }
        this.setHiddenStatus();
    }

    hide_grid() {
        if (this.customParameters.HideGrid != null) {
            this.height = 0;
            this.width = 0;
        }

    }
    setHiddenStatus() {
        if (this.customParameters.Hidden == 'Yes')
            this.isHidden = true;
        //is the the required seccode in the user's credentials
        else if (this.customParameters["HiddenIfMissingSecCode"]) {
            //this.data.checkIfCodeInUserSecurity(this.customParameters["HiddenIfMissingSecCode"]).subscribe((ret: boolean) => {
            //    if (ret) {
            //        this.isHidden = false;
            //    }
            //    else {
            //        this.isHidden = true;
            //    }
            //        });
        }
        else this.isHidden = false;
    }

    // returns a formatted time string
    getTimeFormat(d: any, format: string) {
        var hours: number = d.getHours();
        var mm: string = d.getMinutes().toString();
        var ss: string = d.getSeconds().toString();
        var ms: string = d.getMilliseconds().toString();
        var xm: string = (hours > 12) ? "pm" : "am";
        if (hours > 12) hours -= 12;
        var hh: string = hh.toString();
        if (hh.length < 2) hh = "0" + hh;
        if (mm.length < 2) mm = "0" + mm;
        if (ss.length < 2) ss = "0" + ss;
        var formattedTime: string = "";
        switch (format) {
            case "hh:mm:ss xm":
                formattedTime = hh + ":" + mm + ":" + ss + " " + xm;
                break;
            default:
                formattedTime = hh + ":" + mm + ":" + ss + " " + xm;
                break;
        }
        return formattedTime;
    }

    calc_data() {
        this.loadingTemplate =
            `<span class="ag-overlay-loading-center">data is loading...</span>`;
        this.noRowsTemplate =
            `<span class="ag-overlay-loading-center">No data to show</span>`;

        this.getRows = [];
        //Is Grid1, Grid2, Grid3, Grid4 ... case insensitive.
        if (this.DocDefTemplate.tType.toUpperCase().startsWith("GRID") && this.DocDefTemplate.tType.toUpperCase() != "GRID")
            this.gridIsSecondary = true;
        if (this.customParameters.CacheData == null)
            this.cacheData = true
        else
            this.cacheData = this.customParameters.CacheData == "False" ? false : true;

        //get unique rows and the field to be sorted on (default to first field)
        for (let i: number = 0; i < this.lstDocData.length; i++) {
            if (this.getRows.map(function (e) { return e }).indexOf(this.lstDocData[i].docDefDataRowID) === -1) {
                this.getRows.push(this.lstDocData[i].docDefDataRowID)
            }
        }
        // cols
        this._columnDefs = [];
        let _this = this;

        for (let template of this.lstChildDocDefTemplate) {
            let col = {};

            col["headerClass"] = 'ag-grid-HeaderClass'; // must be defined in the project golbal styles
            if (template.dictCustomParameters.pinned) {
                col["pinned"] = 'left';
            }
            col["headerName"] = template.tLabel;
            if (template.dictCustomParameters.width) {
                col["width"] = parseInt(template.dictCustomParameters.width);
            }
            // col["rowSelection"] = "multiple";
            col["field"] = "T" + template.docDefTemplateID.toString();
            if (template.tLabel == "Remove")
                col["sortable"] = false;
            else
                col["sortable"] = true;
            if (typeof template.dictCustomParameters.numberFmt !== 'undefined')
                col["filter"] = 'agNumberColumnFilter'
            else if (typeof template.dictCustomParameters.dateFmt !== 'undefined')
                col["filter"] = 'agDateColumnFilter'
            else
                col["filter"] = true;
            if (template.dictCustomParameters.numberFmt) {
                // not is not a number
                if (!isNaN(template.dictCustomParameters.numberFmt))
                    col["valueFormatter"] = function (params) {
                        if (!params.value)
                            return "";
                        let ret = parseFloat(params.value).toFixed(+template.dictCustomParameters.numberFmt);
                        return ret;
                    }
            }
            if (template.dictCustomParameters.tooltip) {
                if (template.dictCustomParameters.tooltip == template.templateCode)
                    col["tooltipField"] = col["field"];
                else {
                    let _colToolTip: NJDocDefTemplate = this.lstChildDocDefTemplate.find(x => x.templateCode == template.dictCustomParameters.tooltip)[0];
                    if (_colToolTip)
                        col["tooltipField"] = "T" + _colToolTip.docDefTemplateID.toString();
                }
            }
            if (template.dictCustomParameters.dollarFmt) {
                // not is not a number
                if (!isNaN(template.dictCustomParameters.dollarFmt))
                    col["valueFormatter"] = function (params) {
                        if (!params.value)
                            return "";
                        let ret = "$" + parseFloat(params.value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        return ret;
                    }
            }
            if (template.dictCustomParameters.dateFmt !== undefined) {
                let IDateFilterParams = {
                    debounceMs: 2000,
                    comparator: function (filterValue:Date, cellValue:string) {                                          
                        if (template.dictCustomParameters.dateFmt == "MM/dd/yyyy") {
                            const dateAsString = cellValue;
                            if (dateAsString == null) {
                                return 0;
                            }
                            const date = dateAsString.split(' ');
                            const dateParts = date[0].split('/');
                            const year = Number(dateParts[2]);
                            const month = Number(dateParts[0]) - 1;
                            const day = Number(dateParts[1]);
                            const cellDate = new Date(year, month, day);
                            if (cellDate < filterValue) {
                                return -1;
                            } else if (cellDate > filterValue) {
                                return 1;
                            }
                            return 0;
                        }
                        else
                            return 1;
                    }
                }
                col["filterParams"] = IDateFilterParams;                
            }
            else {
                col["filterParams"] = {
                    debounceMs: 2000
                }
            }    
            
            if (template.dictCustomParameters.dateFmt !== undefined) {                
                col["comparator"] = function (date1: string, date2: string) {                    
                    const date1Number = Date.parse(date1);
                    const date2Number = Date.parse(date2);
                    if (date1Number === null && date2Number === null) {
                        return 0;
                    }
                    if (date1Number === null) {
                        return -1;
                    }
                    if (date2Number === null) {
                        return 1;
                    }
                    return (date1Number > date2Number) ? 1 : -1;
                }
                col["valueFormatter"] = function (params) {                    
                    if (!params.value)
                        return "";
                    let d = new Date(params.value.replaceAll('-', '/'));
                    let month = '' + (d.getMonth() + 1);
                    let day = '' + d.getDate();
                    let year = d.getFullYear();

                    if (month.length < 2) month = '0' + month;
                    if (day.length < 2) day = '0' + day;
                    let ret = "";
                    switch (template.dictCustomParameters.dateFmt) {
                        case "yyyy-MM-dd":
                            ret = [year, month, day].join('-');
                            break;
                        case "MM-dd-yyyy":
                            ret = [month, day, year].join('-');
                            break;
                        case "yyyy/MM/dd":
                            ret = [year, month, day].join('/');
                            break;
                        case "MM/dd/yyyy":
                            ret = [month, day, year].join('/');
                            break;
                        case "24HR":
                            let intHours = d.getHours();
                            let minutes = '' + d.getMinutes();
                            let seconds = '' + d.getSeconds();
                            if (intHours === 0) intHours = 12;
                            let hours = '' + intHours;
                            if (hours.length < 2) hours = '0' + hours;
                            if (minutes.length < 2) minutes = '0' + minutes;
                            if (seconds.length < 2) seconds = '0' + seconds;
                            ret = "MM/dd/yyyy hh:mm:ss";
                            ret = ret.replace("MM", month);
                            ret = ret.replace("dd", day);
                            ret = ret.replace("yyyy", year.toString());
                            ret = ret.replace("hh", hours);
                            ret = ret.replace("mm", minutes);
                            ret = ret.replace("ss", seconds);
                            break;
                        case "AMPM":
                            {
                                let intHours = d.getHours();
                                let minutes = '' + d.getMinutes();
                                let xm = intHours > 12 ? "PM" : "AM";
                                if (params.value.includes('PM')) {
                                    xm = 'PM';
                                } else if (params.value.includes('AM')) {
                                    xm = 'AM';
                                }
                                if (intHours > 12) intHours -= 12;
                                if (intHours === 0) intHours = 12;
                                let hours = '' + intHours;
                                if (hours.length < 2) hours = '0' + hours;
                                if (minutes.length < 2) minutes = '0' + minutes;
                                ret = "MM/dd/yyyy hh:mm xm";
                                ret = ret.replace("MM", month);
                                ret = ret.replace("dd", day);
                                ret = ret.replace("yyyy", year.toString());
                                ret = ret.replace("hh", hours);
                                ret = ret.replace("mm", minutes);
                                ret = ret.replace("xm", xm);
                                break;
                            }
                        case "AMPMwSeconds":
                            {
                                let intHours = d.getHours();
                                let minutes = '' + d.getMinutes();
                                let seconds = '' + d.getSeconds();
                                let xm = intHours > 12 ? "PM" : "AM";
                                if (params.value.includes('PM')) {
                                    xm = 'PM';
                                } else if (params.value.includes('AM')) {
                                    xm = 'AM';
                                }
                                if (intHours > 12) intHours -= 12;
                                if (intHours === 0) intHours = 12;
                                let hours = '' + intHours;
                                if (hours.length < 2) hours = '0' + hours;
                                if (minutes.length < 2) minutes = '0' + minutes;
                                // Fix for Ticket #32456
                                if (seconds.length < 2) seconds = '0' + seconds;
                                ret = "MM/dd/yyyy hh:mm:ss xm";
                                ret = ret.replace("MM", month);
                                ret = ret.replace("dd", day);
                                ret = ret.replace("yyyy", year.toString());
                                ret = ret.replace("hh", hours);
                                ret = ret.replace("mm", minutes);
                                ret = ret.replace("ss", seconds);
                                ret = ret.replace("xm", xm);
                                break;
                            }
                        default:
                            if (template.dictCustomParameters.dateFmt.length > 10) {
                                let intHours = d.getHours();
                                let minutes = '' + d.getMinutes();
                                let seconds = '' + d.getSeconds();
                                let xm = intHours > 12 ? "PM" : "AM";
                                if (intHours > 12) intHours -= 12;
                                if (intHours === 0) intHours = 12;
                                let hours = '' + intHours;
                                if (hours.length < 2) hours = '0' + hours;
                                if (minutes.length < 2) minutes = '0' + minutes;
                                if (seconds.length < 2) seconds = '0' + seconds;
                                ret = template.dictCustomParameters.dateFmt;
                                ret = ret.replace("MM", month);
                                ret = ret.replace("dd", day);
                                ret = ret.replace("yyyy", year.toString());
                                ret = ret.replace("hh", hours);
                                ret = ret.replace("mm", minutes);
                                ret = ret.replace("ss", seconds);
                                ret = ret.replace("xm", xm);
                            }
                            else {
                                ret = [month, day, year].join('-');
                            }
                            break;
                    }
                    if ((month === "1" || month === "01") && (day === "1" || day === "01") && year.toString() === "1900")
                        ret = "";
                    return ret;
                }
            }

            if (template.dictCustomParameters.ssnFmt) {
                col["valueFormatter"] = function (params) {
                    if (!params.value) return "";
                    let ssn = params.value.replace(/\D/g, '');
                    if (ssn.length != 9) return params.value;
                    let ret = "";
                    switch (template.dictCustomParameters.ssnFmt) {
                        case "MaskedAllButLast4":
                            ret = "XXX-XX-" + ssn.substring(5);
                            break;
                        case "Dashed":
                            ret = ssn.substring(0, 3) + "-" +
                                ssn.substring(3, 5) + "-" +
                                ssn.substring(5);
                            break;
                        default:
                            ret = params.value;
                    }
                    return ret;
                }
            }

            // Returns "Yes" if there is a value; "No" if not
            if (template.dictCustomParameters.yesNoFmt) {
                col["valueFormatter"] = function (params) {
                    if (params.value === null || params.value === undefined) return "";
                    return params.value.trim().length === 0 ? "No" : "Yes";
                }
            }

            if (template.dictCustomParameters.isPhone) {
                col["valueFormatter"] = function (params) {
                    if (!params.value)
                        return "";
                    var lenDiff = params.value.length;
                    var x = params.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                    params.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                    //if junk was typed in then the above code will strip it out, but we need to create a new string to override the junk.
                    if (lenDiff - params.value.length > 0) {
                        params.value = new String(params.value);
                    }
                    return params.value;
                }
            }

            if (template.dictCustomParameters.dropdown !== undefined || template.dictCustomParameters.gidDropdown !== undefined ) {
                col["cellRenderer"] = "DropdownRendererComponent";
                //col["cellEditorFramework"] = "DropdownRendererComponent";
                //col["editable"] = true;

                col["valueFormatter"] = function (params) {
                    if (!params.value)
                        return 0;
                    else
                        return params.value;
                }
                // define cellRendererParams
                let cellParamscol = {};
                if (template.dictCustomParameters.gidDropdown) {
                    cellParamscol["dropdown"] = template.dictCustomParameters.gidDropdown.toLowerCase() == 'dropdown';
                } else {
                    cellParamscol["dropdown"] = template.dictCustomParameters.dropdown.toLowerCase() == 'dropdown';
                }
                cellParamscol["template"] = template;
                cellParamscol["origHeight"] = -1;
                if (template.dictCustomParameters.DropdownHeight)
                    cellParamscol["DropdownHeight"] = template.dictCustomParameters.DropdownHeight;
                else
                    cellParamscol["DropdownHeight"] = 200;
                cellParamscol["lstDocDefTemplateLookup"] = this.lstDocDefTemplateLookup;
                col["cellRendererParams"] = cellParamscol;
                cellParamscol["onClick"] = this.onDropdownClick.bind(_this);
                //col["cellEditorParams"] = cellParamscol;
            }
            if (template.tType == "Button") {
                if (template.dictCustomParameters.Link) {
                    col["cellRenderer"] = "ButtonRendererComponent";
                    col["valueFormatter"] = function (params) {
                        if (!params.value)
                            return "";
                        else
                            return params.value;
                    }

                    // define cellRendererParams
                    this._cellRendererParamsDefs = [];
                    let cellParamscol = {};

                    cellParamscol["onClick"] = this.onLinkButtonClick.bind(_this);
                    cellParamscol["template"] = template;
                    cellParamscol["isLink"] = true;
                    let colEnabled: boolean = this.isEnabled;
                    if (template.dictCustomParameters.isEnabled) {
                        if (this.isEnabled)
                            colEnabled = (template.dictCustomParameters.isEnabled.toLowerCase() === 'true');
                    }
                    if (colEnabled === true)
                        cellParamscol["isDisabled"] = false;
                    else
                        cellParamscol["isDisabled"] = true;
                    if (template.dictCustomParameters.ButonIcon) {
                        cellParamscol["ButonIcon"] = true;
                    }
                    col["cellRendererParams"] = cellParamscol;
                }
                else if (template.dictCustomParameters.remove) {
                    col["cellRenderer"] = "ButtonRendererComponent";
                    col["valueFormatter"] = function (params) {
                        if (!params.value)
                            return "";
                        else
                            return params.value;
                    }

                    // define cellRendererParams
                    this._cellRendererParamsDefs = [];
                    let cellParamscol = {};
                    cellParamscol["onClick"] = this.onDeleteButtonClick.bind(_this);
                    cellParamscol["template"] = template;
                    cellParamscol["label"] = template.tLabel;
                    cellParamscol["isLink"] = false;

                    let colEnabled: boolean = this.isEnabled;
                    if (template.dictCustomParameters.isEnabled) {
                        if (this.isEnabled)
                            colEnabled = template.dictCustomParameters.isEnabled;
                    }
                    if (colEnabled === true)
                        cellParamscol["isDisabled"] = false;
                    else
                        cellParamscol["isDisabled"] = true;

                    col["cellRendererParams"] = cellParamscol;
                }

                else {
                    col["cellRenderer"] = function (params) {
                        if (params.value !== undefined) {
                            return '<a href="# " onclick="return false;">' + params.value + '</a>'
                        } else {
                            return '<img src="images/loading.gif">';
                        }
                    }
                }
            }

            if (template.tType == "CheckBox") {
                col["editable"] = true;
                col["cellRenderer"] = "CheckboxRendererComponent";
                col["valueFormatter"] = function (params) {
                    if (!params.value)
                        return false;
                    else
                        return params.value;
                }
                this._cellRendererParamsDefs = [];
                let cellParamscol = {};
                cellParamscol["template"] = template;
                cellParamscol["lstDocDefTemplateLookup"] = this.lstDocDefTemplateLookup;
                cellParamscol["onClick"] = this.onCheckBoxClick.bind(this);

                if (template.dictCustomParameters.isDisabled) {
                    cellParamscol["isDisabled"] = template.dictCustomParameters.isDisabled;
                } else {
                    if (template.customParameters.includes("isDisabled=true"))
                        cellParamscol["isDisabled"] = true;
                    else if (template.customParameters.includes("isDisabled=false"))
                        cellParamscol["isDisabled"] = false;
                    else
                        cellParamscol["isDisabled"] = !this.isEnabled;
                }

                col["cellRendererParams"] = cellParamscol;
            }
            if (!col["cellRenderer"])
                if (this._columnDefs.length == 0)
                    col["cellRenderer"] = 'loadingRenderer'
            if (template.dictCustomParameters.hideCol !== undefined) {
                if (template.dictCustomParameters.hideCol == "true")
                    col["hide"] = true;
            }
            if (template.dictCustomParameters.autoHeight !== undefined) {
                if (template.dictCustomParameters.autoHeight.toLowerCase() == 'true')
                    col["autoHeight"] = true;

            }
            if (template.dictCustomParameters.wrapText !== undefined) {
                if (template.dictCustomParameters.wrapText.toLowerCase() == 'true') {
                    col["cellStyle"] = JSON.parse('{ "white-space": "normal" }');
                }
            }
            if (template.dictCustomParameters.prelineWrapText !== undefined) {
                if (template.dictCustomParameters.prelineWrapText.toLowerCase() == 'true') {
                    col["cellStyle"] = JSON.parse('{ "white-space": "pre-line" }');
                }
            }
            this._columnDefs.push(col);

        }
        this.getRowNodeId = function (item) {
            return item.id;
        };

        // data
        this._rowData = [];
        this.components = {
            loadingRenderer: function (params) {
                if (params.value !== undefined) {
                    return params.value;
                    //<img src="https://raw.githubusercontent.com/ag-grid/ag-grid/master/grid-packages/ag-grid-docs/src/images/loading.gif">
                } else {//<span><i class="fas fa-cog fa-spin"></i></span>
                    return '<img src="images/loading.gif">';
                }
            }
        };
    }
    // Purpose: To return the selected data in the grid
    getAllSelectedRowData() {
        let selectedNodes = this.gridApi.getSelectedNodes();
        let selectedData = selectedNodes.map(node => node.data);
        let retData: Array<string> = new Array<string>();
        for (var i = 0; i < selectedData.length; i++) {
            retData.push(selectedData[i]);
        }
        return retData;
    }
    // Purpose: If custom parameter KeyColumnField is set:
    //              Return the KeyColumnField column for the selected row(s)
    //              Else return the selected data in the grid
    getSelectedRowData() {
        let templateCodeKey = this.customParameters.KeyColumnField
        let lstTemplate = this.lstChildDocDefTemplate.find(item => item.templateCode == templateCodeKey);
        if (lstTemplate) {
            var keyColumn;
            this.selectedRowkeyTemplateId = lstTemplate.docDefTemplateID;
            keyColumn = "T" + lstTemplate.docDefTemplateID;
        }
        else {
            templateCodeKey = "";
        }
        let selectedNodes = this.gridApi.getSelectedNodes();
        let selectedData = selectedNodes.map(node => node.data);
        let retData: Array<string> = new Array<string>();
        if (templateCodeKey == "")
            for (var i = 0; i < selectedData.length; i++) {
                retData.push(selectedData[i]);
            }
        else
            for (var i = 0; i < selectedData.length; i++) {
                retData.push(selectedData[i][keyColumn]);
            }
        // alert(`Selected Nodes:\n${JSON.stringify(selectedData)}`);
        return retData;
    }

    deselectAllRows() {
        this.gridApi.deselectAll();
    }

    // Purpose: get column data by coloumn template code
    // this data could be used for populating a drop down             
    //              
    getColumnDataByColumnTemplateCode(templateCodeKey: string) {
        let lstTemplate = this.lstChildDocDefTemplate.find(item => item.templateCode == templateCodeKey);

        var keyColumn = lstTemplate ? "T" + lstTemplate.docDefTemplateID: "";

        let rowData: Array<any> = [];
        this.gridApi.forEachNode(function (node) {
            rowData.push(node.data[keyColumn]);
        });
        return rowData;
    }

    onCheckBoxClick(params) {
        //let DOMessage: DOData = new DOData();
        //DOMessage.njDocData = params;
        //DOMessage.njDocData.dataValue = params.data["T" + params.template.docDefTemplateID];
        //DOMessage.njDocDefTemplate = params.template;
        //DOMessage.lstChildDocDefTemplate = this.lstChildDocDefTemplate;
        //DOMessage.customParameters = params.template.customParameters;
        //this.clickBut.emit(DOMessage);
        this.onCheckBoxClickSave(params)
    }
    onCheckBoxClickSave(params) {
        let DocDataSave: DocdefDataVM = new DocdefDataVM();
        let lstDocdata: Array<NJDocData> = new Array<NJDocData>();
        let itemDocdata: NJDocData = new NJDocData();
        DocDataSave.docdata = lstDocdata;
        let checkBoxValue = params.data["T" + params.template.docDefTemplateID];
        if (params.template.lookupTypeId > 0) {
            let lstTemplateItem: NJReadDocDefTemplateLookup;
            if (checkBoxValue == true) {
                lstTemplateItem = this.lstDocDefTemplateLookup.find(item => item.shortDesc == "Y" && item.lookupTypeId == params.template.lookupTypeId);
            } else {
                lstTemplateItem = this.lstDocDefTemplateLookup.find(item => item.shortDesc == "N" && item.lookupTypeId == params.template.lookupTypeId);
            }
            if (lstTemplateItem)
                itemDocdata.dataValue = lstTemplateItem.lookupId.toString();
        } else {
            itemDocdata.dataValue = checkBoxValue;
        }
        if (params.template.customParameters) {
            if (params.template.customParameters.indexOf('CheckBoxSetInt="true"') >= 0) {
                if (itemDocdata.dataValue) {
                    itemDocdata.dataValue = '1';
                } else {
                    itemDocdata.dataValue = '0';
                }
            }
        }
        itemDocdata.docDefTemplateID = params.template.docDefTemplateID;
        itemDocdata.docDefDataRowID = params.data.id;
        lstDocdata.push(itemDocdata);
        DocDataSave.loaderKey = this.loaderKey;
        var _this = this;

        if ((this.customParameters.skipPostDocDefData == "True" || this.skipAGGridChkBoxPostDocDefData == true) && this.customParameters.DontskipPostDocDefData != "True") {
            let DOMessage: DOData = new DOData();
            DOMessage.njDocData = params;
            DOMessage.njDocData.dataValue = params.data["T" + params.template.docDefTemplateID];
            DOMessage.njDocData.docDefDataRowID = params.data.id;
            DOMessage.njDocDefTemplate = params.template;
            DOMessage.lstChildDocDefTemplate = this.lstChildDocDefTemplate;
            DOMessage.lstDocData = this.lstDocData;
            DOMessage.customParameters = params.template.customParameters;
            this.clickBut.emit(DOMessage);

            //return _this.onSaveComplete();
        }
        else {
            this.data.saveDocDefData(DocDataSave)
                .subscribe(function () {
                    // ********************************************
                    // after finishing saving data than call emit
                    // ********************************************
                    let DOMessage: DOData = new DOData();
                    DOMessage.njDocData = params;
                    DOMessage.njDocData.dataValue = params.data["T" + params.template.docDefTemplateID];
                    DOMessage.njDocDefTemplate = params.template;
                    DOMessage.lstChildDocDefTemplate = this.lstChildDocDefTemplate;
                    DOMessage.customParameters = params.template.customParameters;
                    _this.clickBut.emit(DOMessage);

                    return _this.onSaveComplete();
                }, function (error) {
                    return _this.errorMessage = error;
                });
        }
    }
    onSaveComplete = function () {
    }
    onDeleteButtonClick(params) {

        let nodeIndex: number = params.data.id;
        let selectedNode: RowNode = this.gridApi.getRowNode(nodeIndex);

        let lstDocData = this.getSelectedLstDocData(selectedNode, nodeIndex);
        let DOMessage: DOData = new DOData();
        DOMessage.njDocData = params;
        DOMessage.njDocData.dataValue = params.data["T" + params.template.docDefTemplateID];
        DOMessage.njDocDefTemplate = params.template;
        DOMessage.lstChildDocDefTemplate = this.lstChildDocDefTemplate;
        DOMessage.lstDocData = lstDocData;
        DOMessage.customParameters = params.template.customParameters;
        this.clickBut.emit(DOMessage);
    }

    onLinkButtonClick(params) {
        if (this.isEnabled) {
            let nodeIndex: number = params.data.id;
            let selectedNode: RowNode = this.gridApi.getRowNode(nodeIndex);
            let lstDocData = this.getSelectedLstDocData(selectedNode, nodeIndex);

            let DOMessage: DOData = new DOData();
            DOMessage.njDocData = params;
            DOMessage.njDocData.dataValue = params.value;
            DOMessage.njDocData.docDefDataRowID = params.node.id;
            DOMessage.njDocDefTemplate = params.template;
            DOMessage.lstChildDocDefTemplate = this.lstChildDocDefTemplate;
            DOMessage.lstDocData = lstDocData;
            DOMessage.customParameters = params.template.customParameters;
            this.clickBut.emit(DOMessage);
        }

    }
    getSelectedLstDocData(selectedNode: RowNode, nodeIndex: number): Array<NJDocData> {
        let k: keyof typeof selectedNode.data;
        let lstDocData: Array<NJDocData> = new Array<NJDocData>();
        let docDataHdrId: number = -1;
        let docDefTemplateID: number = -1;
        let docDefDataRowID: number = nodeIndex;
        let docDefDataRowParID: number = 0;

        let DocData: NJDocData;
        for (k in selectedNode.data) {
            const dataValue = selectedNode.data[k];
            let strKey: string = k;

            if (strKey.substring(0, 1) == "T") {

                docDefTemplateID = + strKey.substring(1);

                DocData = new NJDocData();
                DocData.dataValue = dataValue;
                DocData.docDefTemplateID = docDefTemplateID;
                DocData.docDefDataRowParID = docDefDataRowParID;
                DocData.docDefDataRowID = docDefDataRowID;
                DocData.docDataHdrId = docDataHdrId;
                lstDocData.push(DocData);
            }
        }
        return lstDocData;
    }
    onDropdownClick(params) {
        //save selection
        if (Number.isInteger(params.event)) {
            //params.node.setRowHeight(params.origHeight);
            let DocDataSave: DocdefDataVM = new DocdefDataVM();
            let lstDocdata: Array<NJDocData> = new Array<NJDocData>();
            let itemDocdata: NJDocData = new NJDocData();
            DocDataSave.docdata = lstDocdata;
            itemDocdata.dataValue = params.value;
            itemDocdata.docDefTemplateID = params.template.docDefTemplateID;
            itemDocdata.docDefDataRowID = params.node.id;
            lstDocdata.push(itemDocdata);
            DocDataSave.loaderKey = this.loaderKey;
            var _this = this;
            this.data.saveDocDefData(DocDataSave)
                .subscribe(function () {
                    // ********************************************
                    // after finishing saving data than call emit
                    // ********************************************
                    let DOMessage: DOData = new DOData();
                    DOMessage.njDocData = params;
                    DOMessage.njDocData.dataValue = params.node.data["T" + params.template.docDefTemplateID];
                    DOMessage.njDocDefTemplate = params.template;
                    DOMessage.lstChildDocDefTemplate = this.lstChildDocDefTemplate;
                    DOMessage.customParameters = params.template.customParameters;
                    _this.clickBut.emit(DOMessage);

                    return _this.onSaveComplete();
                }, function (error) {
                    return _this.errorMessage = error;
                });
        } else
        //save selection
        {
            if (params.event == "resetRowHeights") {
                params.node.setRowHeight(params.DropdownHeight);
            }
            if (params.event == "blur")
                params.node.setRowHeight(params.origHeight);
        }
        this.gridApi.onRowHeightChanged();
    }
    getDataSource(count) {
        function GridDatasource(rowCount) {
            this.rowCount = rowCount;
        }
        let _this = this;
        GridDatasource.prototype.getRows = function (params) {
            var rowsThisPage = [];
            for (var rowIndex = params.startRow; rowIndex < params.endRow; rowIndex++) {
                var record = {};
                let docDataRowID = _this.getRows[rowIndex];
                for (let template of _this.lstChildDocDefTemplate) {
                    let data = _this.lstDocData.find(d => d.docDefDataRowID == docDataRowID && d.docDefTemplateID == template.docDefTemplateID);
                    record["T" + template.docDefTemplateID.toString()] = data ? data.dataValue : "";
                    record["id"] = docDataRowID;
                }
                rowsThisPage.push(record);
            }
            params.successCallback(rowsThisPage);
        };
        return new GridDatasource(count);
    }

    onCellDoubleClicked(params) {
        if (this.isEnabled) {
            let DOMessage: DOData = new DOData();
            if (this.customParameters.rowDeselect !== undefined) {
                if (this.customParameters.rowDeselect == "true") {
                    params.node.selectThisNode(true);
                }
            }
            DOMessage.njDocData = params.data;
            DOMessage.njDocDefTemplate = this.DocDefTemplate;
            DOMessage.customParameters = this.customParameters;
            this.doubleClick.emit(DOMessage);
        }
    }

    cellColClicked: any;
    onCellClicked(event: CellClickedEvent) {
        let DOMessage: DOData = new DOData();
        DOMessage.njDocDefTemplate = this.DocDefTemplate;
        let _cellClicked: any = event;
        this.cellColClicked = _cellClicked.colDef.field;
        this.selectionStartIndex = event.rowIndex;
        //Warning: Any thing you put in here will be run twice during a double-click
        this.cellClicked.emit(DOMessage);
    }
    onCheckBoxClicked(event: Event) {
    }
    onRowClicked(params) {
        if (this.customParameters.rowDeselect !== undefined) {
            if (this.customParameters.rowDeselect == "true") {
                if (this.selectedRow == null || this.selectedRow != params.data) {
                    this.selectedRow = params.data;
                }
                else {
                    params.node.selectThisNode(false);
                    this.selectedRow = null;
                }
            }
            else {
                this.selectedRow = params.data;
            }
        }
        else {
            this.selectedRow = params.data;
        }
        if (this.customParameters.KeyColumnField !== undefined) {
            let templateCodeKey = this.customParameters.KeyColumnField
            let lstTemplate = this.lstChildDocDefTemplate.find(item => item.templateCode == templateCodeKey);
            if (lstTemplate) {
                var keyColumn;
                this.selectedRowkeyTemplateId = lstTemplate.docDefTemplateID;
                keyColumn = "T" + lstTemplate.docDefTemplateID;

                let DOMessage: DOData = new DOData();
                let DocData: NJDocData = new NJDocData;

                var dataValue;
                dataValue = params.data[keyColumn];
                if (this.selectedRow == null && this.customParameters.rowDeselect !== undefined) {
                    if (this.customParameters.rowDeselect == "true") {
                        DOMessage.njDocData = null;
                    }
                }
                else {
                    DocData.dataValue = dataValue;
                    DOMessage.njDocData = DocData;
                }
                DOMessage.njDocDefTemplate = this.DocDefTemplate;
                DOMessage.customParameters = this.customParameters;
                this.clickBut.emit(DOMessage);
            } 
        }
        else if (this.hasEvent) {
            this.selectedRow['cellClicked'] = this.cellColClicked;
            let DOMessage: DOData = new DOData();
            let DocData: NJDocData = new NJDocData;

            var dataValue;
            dataValue = this.selectedRow;

            DocData.dataValue = dataValue;
            DOMessage.njDocData = DocData;
            DOMessage.lstDocData = this.lstDocData;
            DOMessage.lstChildDocDefTemplate = this.lstChildDocDefTemplate;
            DOMessage.njDocDefTemplate = this.DocDefTemplate;
            DOMessage.customParameters = this.customParameters;
            this.clickBut.emit(DOMessage);
        }
        this.selectedRowData.emit(params.data);
    }

    //Updating the Grid Data Directly without making api call By passing new Row Data to Display .
    updateInfiniteRowModel(newRowData: any) {
        let _this = this;
        let processData = (params) => {
            params.context = _this.DocDefTemplate;
            let lstDocDataLocal: Array<NJDocData> = new Array<NJDocData>();
            if (newRowData) {
                lstDocDataLocal = newRowData.slice(params.startRow * this.lstChildDocDefTemplate.length, (params.endRow+1) * this.lstChildDocDefTemplate.length);

                if (!_this.cacheData || _this.gridIsSecondary) {
                    if (params.startRow == 0)
                        _this._getRows = [];
                    for (let i: number = 0; i < lstDocDataLocal.length; i += this.lstChildDocDefTemplate.length - 1) {
                        if (_this.getRows.map(function (e) { return e }).indexOf(lstDocDataLocal[i].docDefDataRowID) === -1) {
                            _this.getRows.push(lstDocDataLocal[i].docDefDataRowID);
                        }
                    }
                }
            }
            let rowDataLocal: Array<number> = new Array<number>();
            for (let i: number = 0; i < lstDocDataLocal.length; i++) {
                if (rowDataLocal.map(function (e) { return e }).indexOf(lstDocDataLocal[i].docDefDataRowID) === -1)
                    rowDataLocal.push(lstDocDataLocal[i].docDefDataRowID);
            }
            var rowsThisPage = [];
            setTimeout(function () {
                for (var rowIndex = 0; rowIndex < Math.min(rowDataLocal.length, params.endRow - params.startRow); rowIndex++) {
                    var record = {};
                    let docDataRowID = rowDataLocal[rowIndex];
                    for (let template of _this.lstChildDocDefTemplate) {
                        let data = lstDocDataLocal.find(d => d.docDefDataRowID == docDataRowID && d.docDefTemplateID == template.docDefTemplateID);
                        record["T" + template.docDefTemplateID.toString()] = data ? data.dataValue : "";
                        record["id"] = docDataRowID == undefined ? null : docDataRowID.toString();
                    }
                    rowsThisPage.push(record);
                }
                params.successCallback(rowsThisPage, _this.getLastRowIndex(_this.getRows.length, params));
                if (_this.getRows.length == 0)
                    _this.gridApi.showNoRowsOverlay();
                else
                    _this.gridApi.hideOverlay();
                _this.onRequestRows(false);

            }, 500);
        }
        let datasource: IDatasource = {
            rowCount: null,
            getRows: function (params: any): void {
                if (_this.params != undefined) {
                    if (_this.params.filterModel[0] != undefined)
                        params.filterModel = _this.params.filterModel;
                }

                _this.params = params;
                _this.onRequestRows(true);
                //Sorting and Filtering Must be done in Server Side
                _this.data.loadGridData(_this.DocDefTemplate.templateCode, params, _this.loaderKey, _this.cutoffDate, _this.parentLoaderKey)
                        .subscribe(
                            (ret: boolean) => {
                                if (ret) {
                                    if (_this.data.gridDataVM.docdata) {
                                        newRowData = _this.data.gridDataVM.docdata;
                                        processData(params);
                                    }
                                }

                            }
                        )
                        ,
                        (err: any) => console.log(err),
                        () => {
                        }
            },
        };
        this.gridApi.setDatasource(datasource);
    }


    callGridRefresh() {
        //this.gridApi.redrawRows();
        //this.gridApi.setDatasource()
        //this.gridApi.refreshInfiniteCache();
        if (this.gridApi !== null && this.gridApi !== undefined)
            this.gridApi.purgeInfiniteCache();
    }
    SetColumnFilter(columnTemplateCode: string, value: string) {
        let col = this.lstChildDocDefTemplate.find(t => t.templateCode === columnTemplateCode);
        if (col != undefined) {
            let colName = "T" + col.docDefTemplateID;

            // Get a reference to the filter instance
            const filterInstance = this.gridApi.getFilterInstance(colName);

            // Set the filter model
            filterInstance.setModel({
                filterType: 'text',
                type: 'contains',
                filter: value,
            });

            // Tell grid to run filter operation again
            this.gridApi.onFilterChanged();
        }
        else alert("The template code '" + columnTemplateCode +
            "' did not match any columns within grid '" + this.DocDefTemplate.templateCode + "'.");
    }
    SetFilterModel(templateCode: string, value: string, customFilter: string = "") {
        if (templateCode == "") {
            this.gridApi.setFilterModel(null);
            this.gridApi.setSortModel(null);
            this.ExternalFilterModel = "";

            for (let template of this.lstChildDocDefTemplate) {
                if (this.params)
                    if (this.params.filterModel["T" + template.docDefTemplateID.toString()]) {
                        delete this.params.filterModel["T" + template.docDefTemplateID.toString()];
                    }
            }

        } else {
            this.ExternalFilterModel = "";
            for (let template of this.lstChildDocDefTemplate) {
                if (template.templateCode == templateCode) {

                    if (customFilter === "") // Set the filterType if the customFilter has net be set by the caller
                        if (template.customParameters.includes("dateFmt")) {
                            // --- Test Date Filters - could not get the actual date filters to work --
                            //  var dateVal: string = "2022-04-28";
                            //  customFilter = '{"filterType":"date","type":"equals","dateTo":"null","dateFrom":"' + dateVal + '"}';  // for dates
                            //  customFilter = '{"filterType":"date","type":"equals","dateTo":"' + dateVal + ',"dateFrom":"' + dateVal + '"}';  // for dates
                            //  customFilter = '{"filterType":"date","type":"equals","filter":"' + dateVal + '"}'; // for dates
                            var formattedDate = this.formatDate(value);                            
                            customFilter = '{"filterType":"text","type":"contains","filter":"' + formattedDate + '"}'; // for date
                        }
                        else
                            customFilter = '{"filterType":"text","type":"contains","filter":"' + value + '"}'; // for text
                    this.ExternalFilterModel = customFilter;
                    this.ExternalFilterKey = "T" + template.docDefTemplateID.toString();

                    let parsedFilterModel = JSON.parse(this.ExternalFilterModel)
                    if (parsedFilterModel.filter == "") {
                        if (this.params.filterModel[this.ExternalFilterKey])
                            delete this.params.filterModel[this.ExternalFilterKey];
                    }
                    else
                        if (this.params != undefined)
                            this.params.filterModel[this.ExternalFilterKey] = parsedFilterModel;
                }
            }
        }
    }

    private formatDate(ds: string): string {  // Returns "mm/dd/yyyy"
        let date = new Date(ds);
        let dateString: string =
            ('0' + (date.getMonth() + 1)).slice(-2) + "/" +
            ('0' + date.getDate()).slice(-2) + "/" +
            date.getFullYear();
        return dateString;
    }

    onViewportChanged(event: any) {
        this.headerHeightSetter()
        //if (event.lastRow>= 0) {
        //    this.FirstDisplayedRow = event.firstRow;
        //    this.LastDisplayedRow = event.lastRow
        //}
    }
    //Call from Wait
    onRequestRows(message: boolean) {
        this.requestRows.emit(message);
    }

    FilterColumn(columntoFilter: string, selectedValue: string) {
        var FilterComponent = this.gridApi.getFilterInstance(columntoFilter);
        FilterComponent.selectNothing(); //Cleared all options
        FilterComponent.selectValue(selectedValue)  //added the option i wanted
        FilterComponent.onFilterChanged();
    }

    setFilterModel(Filter: any) {
        this.gridApi.setFilterModel(Filter);
    }
    api: any;// this is a dummy variable to make VS compile the code. When this function is called this is a different scope that has an api.
    headerHeightSetter() {
        var padding = 20;
        var height = headerHeightGetter() + padding;
        if (this.gridApi && height > 20) {
            this.gridApi.setHeaderHeight(height);
            this.gridApi.resetRowHeights();
        };
    }

}

function headerHeightGetter() {
    var columnHeaderTexts = Array.from(
        document.querySelectorAll('.ag-header-cell-text'),
    );
    var columnHeaderText2 = Array.from(
        document.querySelectorAll('ag-header ag-pivot-off'),
    );

    var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
    );
    var clientHeights2 = columnHeaderText2.map(
        headerText => headerText.clientHeight
    );
    var tallestHeaderTextHeight = clientHeights.reduce((a, b) => Math.max(a, b), -Infinity);

    return tallestHeaderTextHeight;
}

